import React, { useContext, useEffect, FC } from 'react';

import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import FilterIcon from '../../../../assets/icons/FilterIcon';
import { DiscoverContext } from '../../../../context/DiscoverContext';
import { colorsPalette } from '../../../../theme';
import useStats from '../../../../utils/hooks/useStats';
import ViewSwitcher from '../ViewSwitcher';
import useStyles from './styles';

interface SearchResultsProps {
  withToggle?: boolean;
  resultsFunc: (count: number) => string | JSX.Element;
  setPage?: (page: number) => void;
  setItemsCount?: (itemsCount: number) => void;
}

export const SearchResults: FC<SearchResultsProps> = ({
  setItemsCount,
  setPage,
  resultsFunc,
  withToggle = false,
}) => {
  const { t } = useTranslation();
  const classes = useStyles(withToggle)();

  const { setOpenFiltersPanel, searchState, setTempSearchState } = useContext(DiscoverContext);

  const { nbHits, page } = useStats();

  useEffect(() => {
    setPage && setPage(page);
  }, [page, setPage]);

  useEffect(() => {
    setItemsCount && setItemsCount(nbHits);
  }, [nbHits, setItemsCount]);

  return (
    <div className={classes.searchResult}>
      <Typography data-testid="resultsAmount" className={classes.text}>
        {nbHits} {resultsFunc(nbHits)}
      </Typography>
      <div className={classes.buttonsWrapper}>
        <Button
          className={classes.filterBtn}
          onClick={() => {
            setTempSearchState(searchState);
            setOpenFiltersPanel(true);
          }}
        >
          <FilterIcon color={colorsPalette.gray} className={classes.icon} />
          {t('page.discover.filters')}
        </Button>
        {withToggle && <ViewSwitcher setPage={setPage} />}
      </div>
    </div>
  );
};

export default SearchResults;
